import { render, staticRenderFns } from "./animePage.vue?vue&type=template&id=66eed3bd&"
import script from "./animePage.vue?vue&type=script&lang=js&"
export * from "./animePage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports